import { SxProps, Theme } from "@mui/material";

export const alertStyles: SxProps<Theme> = {
  width: "100%",
  whiteSpace: "pre-line"
};
